import { MijnRoute } from '../../mijn-navigatie.model';

export const SELF_SERVICE_SHARING_ACCESS: MijnRoute = {
    path: 'toegang-gegevens-delen',
    navigationEvent: 'toToegangGegevensDelen',
    regex: /^\/zelf-regelen\/toegang-gegevens-delen$/,
    webcomponent: 'mijn-klant-zelfservice-webcomponent',
    internalPath: '/toegang-gegevens-delen'
};
